import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface DevisRequest {
  devis_type: string;
  civilite: string;
  nom: string;
  prenom: string;
  date_naissance: string;
  telephone: string;
  email: string;
  profession?: string;
  adresse?: string;
  code_postal?: string;
  ville?: string;
  pays?: string;
  message?: string;
  additional_fields?: { [key: string]: any };
}

export interface DevisResponse {
  success: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class DevisService {
  private apiUrl = `${environment.apiUrl}${environment.apiEndpoint}/devis`;

  constructor(private http: HttpClient) {}

  /**
   * Soumet une demande de devis et envoie un email à contact@brokins.fr
   * @param devis Les données du formulaire de devis
   * @returns Observable avec la réponse du serveur
   */
  submitDevis(devis: DevisRequest): Observable<DevisResponse> {
    return this.http.post<DevisResponse>(`${this.apiUrl}/submit`, devis);
  }
}
